registerComponent("product-blocks/product-asa-fidc-singulare", function (component) {

});
